define(["marionette", "./template/kbConfigTemplate.html"], function (Marionette, KbConfigTemplate) {
  "use strict";

  return {
    view: Marionette.ItemView.extend({
      className: "form-horizontal",
      template: KbConfigTemplate,
      events: {
        "change #kbDefaultSelector": function () {
          const optionSelected = this.$el.find("#kbDefaultSelector option:selected").val();
          this.trigger("change:selected:kb", optionSelected);
        },
        "change #userKbLanguages": function () {
          const optionSelected = this.$el.find("#userKbLanguages option:selected").val();
          this.trigger("change:kb:language", optionSelected);
        },
        "change #userKbTouchPoint": function () {
          const optionSelected = this.$el.find("#userKbTouchPoint option:selected").val();
          this.trigger("change:kb:touchpoint", optionSelected);
        },
        "change #userKbContext": function () {
          const optionSelected = this.$el.find("#userKbContext option:selected").val();
          this.trigger("change:kb:context", optionSelected);
        },
      },
    }),
  };
});
